<template>
  <div class="float-right">
    <b-button @click="openModal" size="sm" class="ml-1" variant="success">{{ $t('btn.add_new') }}</b-button>
    <b-modal
        @ok="handleCreateOk"
        ref="create-question-category-modal"
        :ok-title="$t('btn.save')"
        :cancel-title="$t('btn.cancel')"
        size="lg">
      <template #modal-header>
        <div class="w-100">
          <h4 class="float-left">{{ title }}</h4>
        </div>
      </template>
      <div class="create-question">
        <b-card>
          <b-card-body>
            <p v-if="serverError" class="alert alert-danger">{{ $t(serverError) }}</p>
            <b-form-group
                :label="$t('form.label.category_name')"
                label-cols="4"
                class="flat">
              <b-form-input
                  v-model="name"
                  @keypress="isRestricted($event)"
                  @input="$v.name.$model = $event;"
                  :state="!$v.name.$dirty ? null : !$v.name.$error"
                  :placeholder="$t('form.placeholder.category_name')"
                  trim>
              </b-form-input>
            </b-form-group>
            <p v-if="$v.name.$dirty && !$v.name.required" style="margin: -10px 0 10px 60px;" class="invalid-feedback invalid-feedback-text">{{ errors.name }}</p>

            <b-form-group :label="$t('form.label.icon')" label-cols-sm="4">
              <img v-if="icon" :src="icon" alt="icon"/>
              <button v-if="icon" @click="removeIcon">{{ $t('btn.delete') }}</button>
              <b-form-file
                  :placeholder="$t('import.file.choose_label')"
                  :drop-placeholder="$t('import.file.drop_placeholder')"
                  :browse-text="$t('import.file.browse_text')"
                  id="file" ref="file"></b-form-file>
            </b-form-group>
          </b-card-body>
        </b-card>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <div class="buttons float-right">
            <b-button type="button" variant="secondary" class="mr-2" @click="hideModal">{{ $t('btn.cancel') }}</b-button>
            <b-button type="submit" variant="primary" @click="handleCreateOk">{{ !categoryId ? $t('btn.save') : $t('btn.save_changes') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  components: {  },
  mixins: [validationMixin],
  data() {
    return {
      categoryId: null,
      file: null,
      name: null,
      title: null,
      label: null,
      parent: null,
      icon: null,
      serverError: null,
      errors: {
        name: 'Name is a required field!',
        label: 'Label is a required field!',
        parent: 'Parent category is a required field!'
      },
      apiKey:null,
      selectOptions: null,
      items: null,
    };
  },
  validations: {
    name: {
      required
    }
  },
  methods: {
    removeIcon() {
      axios.delete( `/api/question/question-category/${this.categoryId}/icon`).then(() => {
        this.icon = null;
        this.hideModal();
        this.$emit('removedIcon');
      });
    },
    handleFileUpload(categoryId) {
      this.file = this.$refs.file.files[0];

      if(this.file) {
        this.submitFile(categoryId);
      }
    },
    submitFile(categoryId) {
      let formData = new FormData();
      formData.append('icon', this.file);

      axios.post( `/api/question/question-category/${categoryId}/icon`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      );
    },
    openModal(item) {
      this.$v.$reset();
      let parentCategory;
      this.title = this.$t('question.add_new_question_category');
      this.serverError = null;
      if(item) {
        this.title = this.$t('question.edit_question_category');
        this.categoryId = item.id;

        parentCategory = {
          iconUrl: item.iconUrl,
          name: item.parentName,
          parentId: item.parentId,
          parentLabel: item.parentLabel,
          questionCount: item.questionCount
        }
      }

      this.name = item ? item.name : null;
      this.label = item ? item.label : null;
      this.parent = item ? parentCategory : null;
      this.icon = item ? item.iconUrl : null;

      this.$refs['create-question-category-modal'].show();
    },
    handleCreateOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleCreateSubmit()
    },
    handleCreateSubmit() {
      this.$v.$touch();
      let isValid = this.$v.$invalid === false;
      this.serverError = null;

      const httpMethod = !this.categoryId ? 'post' : 'put';
      const url = '/api/question/question-category';

      if (isValid) {
        let data = {
          name: this.name.trim()
        }

        if (this.categoryId) {
          data['id'] = this.categoryId;
        }

        axios[httpMethod](url, data)
            .then(response => {
              this.handleFileUpload(response.data.id);

              setTimeout(() => {
                this.$parent.$emit('refreshGrid');
                this.hideModal();
              }, 1000);
            }).catch(err => {
          this.serverError = err.response.data.violations[0].label;
        });
      }
    },
    resetProperties() {
      this.name = null;
      this.label = null;
      this.parent = null;
      this.categoryId = null;
      this.file = null;
      this.title = null
      this.icon = null;
      this.serverError = null;
      this.apiKey = null;
      this.selectOptions = null;
      this.items = null;
    },
    hideModal() {
      this.resetProperties();
      this.$refs['create-question-category-modal'].hide();
    },
    isRestricted: function(e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      const allowCharCode = [95];

      if (allowCharCode.indexOf(charCode) > -1) {
        return true;
      }

      if (charCode < 65 || (charCode > 90 && charCode < 97) || charCode > 122) {
        e.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>
